import { ScopedQARules } from "@pages/QARules/ScopedQARules";
import { QARulesScope } from "@pages/QARules/constants";

interface OrgQARulesTabProps {
  organizationId: number;
}

export const OrgQARulesTab: React.FC<OrgQARulesTabProps> = ({ organizationId }) => (
  <ScopedQARules scope={QARulesScope.ORGANIZATION} scopeId={organizationId} />
);
